import styled from 'styled-components';
import { selectColor } from '@panel/commons/core/theme';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ device }) => (device !== 'desktop' ? 4 : 7)}px;
  position: relative;
  font-family: 'Hind';
  font-style: normal;
  font-weight: ${({ device }) => (device !== 'desktop' ? 500 : 600)};
  font-size: ${({ device }) => (device !== 'desktop' ? 12 : 14)}px;
  line-height: 130%;
  margin-top: ${({ device }) => (device === 'tablet' ? 50 : 0)}px;
`;

const ModuleChart = styled.div`
  width: ${({ width }) => width}%;
  height: ${({ height }) => height}px;
  background-image: url(${({ image }) => image});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: ${({ opacityElement }) => opacityElement};
  :hover {
    opacity: 1;
  }
  .textChart {
    height: ${({ device }) => {
      if (device === 'mobile') return '54px';
      return device === 'tablet' ? '60px' : '77px';
    }};
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 359px) {
      height: 45px;
    }
  }
  @media screen and (max-width: 359px) {
    height: 45px;
  }
`;

const CirclePercentage = styled.div`
  width: ${({ device }) => (device !== 'desktop' ? 72 : 80)}px;
  height: ${({ device }) => (device !== 'desktop' ? 32 : 40)}px;
  line-height: ${({ device }) => (device !== 'desktop' ? 32 : 40)}px;
  border-radius: 25px;
  font-size: ${({ device }) => (device !== 'desktop' ? 12 : 16)}px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: ${selectColor('white')};
  color: ${getColor('primary')};
  position: absolute;
  top: ${({ position }) => position}px;
  @media screen and (max-width: 359px) {
    height: ${({ device }) => device === 'mobile' && 24}px;
    top: ${({ device }) => device === 'mobile' && 35}px;
    line-height: ${({ device }) => device === 'mobile' && 24}px;
  }
`;

const CirclePercentageLower = styled(CirclePercentage)`
  @media screen and (max-width: 359px) {
    height: ${({ device }) => device === 'mobile' && 24}px;
    top: ${({ device }) => device === 'mobile' && 84}px;
    line-height: ${({ device }) => device === 'mobile' && 24}px;
  }
`;

const TooltipComponent = styled.div`
  padding: 8px 6px;
  width: 244px;
  white-space: pre-wrap;
  text-align: start;
`;

export { Container, ModuleChart, CirclePercentage, CirclePercentageLower, TooltipComponent };
